import { lazy, Suspense } from "react";
import { Skeleton } from "../components/ui";
import { chainInfo } from "../lib/chains";
import type { WalletPayPanelProps } from "./WalletPayPanel";

// Wallet libraries are heavy; they load only when the customer opens the wallet tab.
const SolanaWalletPay = lazy(() => import("./solana"));
const EvmWalletPay = lazy(() => import("./evm"));
// Compared inline so the bundler sees a build-time constant and drops the mock chunk in production.
const MockWalletPay = import.meta.env.DEV && import.meta.env.VITE_MOCK === "1" ? lazy(() => import("../mock/MockWalletPay")) : null;

export function WalletPay(props: Omit<WalletPayPanelProps, "port">) {
  const family = chainInfo(props.invoice.asset.chain).family;
  const Impl = MockWalletPay ?? (family === "solana" ? SolanaWalletPay : EvmWalletPay);
  return (
    <Suspense fallback={<WalletSkeleton />}>
      <Impl {...props} />
    </Suspense>
  );
}

function WalletSkeleton() {
  return (
    <div className="stack-md" aria-hidden="true">
      <Skeleton width="45%" height={16} />
      <Skeleton height={56} radius={12} />
      <Skeleton height={56} radius={12} />
    </div>
  );
}
